import React, { useEffect } from 'react';
import './contactModal.css'; // Import the CSS file
import { Button, Modal, FormInstance } from 'antd';

// Define the Contact type
interface Contact {
  key: string; // Unique identifier for each contact
  name: string;
  email: string;
}

interface ContactModalProps {
  isModalOpen: boolean;
  onClose: () => void; // Function to close the modal
  onSubmit: (values: Contact) => void;
  selectedContact: Contact | null;
  inputFields: React.ReactNode; // Adjust type based on what inputFields contains
  title: string; // Assuming 'tital' was a typo
  formRef: FormInstance<any>;
}

const ContactModal: React.FC<ContactModalProps> = (
  {
    isModalOpen,
    onClose,
    onSubmit,
    selectedContact,
    inputFields,
    title,
    formRef
  }) => {
    // Populate form fields if editing
    useEffect(() => {
      if (selectedContact) {
        formRef.setFieldsValue(selectedContact);
      } else {
      formRef.resetFields();
    }
  }, [selectedContact, formRef]);

  return (
    <div className="modal">
      <Modal
        title={title}
        open={isModalOpen}
        onOk={() => {
          formRef.validateFields().then(values => {
            onSubmit(values);
          });
        }}
        onCancel={onClose}
        footer={[
          <Button key="back" onClick={onClose}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => {
            formRef.validateFields().then(values => {
              onSubmit(values);
            }).catch(errorInfo => {
              return;
            });
          }}>
            {selectedContact ? 'Update' : 'Add'}
              </Button>,
            ]}
      >
        <div>
          {inputFields}
        </div>
      </Modal>
    </div>
    );
};

export default ContactModal;
